import { dataChevronDoubleLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronDoubleLeft = /*#__PURE__*/createIcon(dataChevronDoubleLeft)
export default IconChevronDoubleLeft
